// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1PReq","overflowing":"ReadFullNote_overflowing__rS9oD"};